import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_SUGGESTED_CATEGORY, GET_SUGGESTED_CATEGORY_SUCCESS, GET_SUGGESTED_CATEGORY_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getSuggestedCategory({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    /* body: { user_id } — returns the category / benefit type / booking to prefill a manual issue with */
    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/suggested-category`,
      method: 'POST',
      headers: { ...filteredHeaders },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_SUGGESTED_CATEGORY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SUGGESTED_CATEGORY_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SUGGESTED_CATEGORY_ERROR, payload: error });
  }
}

export function* watchGetSuggestedCategory() {
  yield takeEvery(GET_SUGGESTED_CATEGORY, getSuggestedCategory);
}

function* getSuggestedCategorySaga() {
  yield all([fork(watchGetSuggestedCategory)]);
}

export default getSuggestedCategorySaga;
